import React from 'react';

const Loader = () => {
  return (
    <div className="loader h-100 w-100">
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
